import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const PermissionDenied = () => (
  <div className="page-content">
    <Container fluid>
      <Row
        className="justify-content-center align-items-center"
        style={{ minHeight: '60vh' }}
      >
        <Col md={8} className="text-center">
          <h2 className="text-danger mb-4">Permission Denied</h2>
          <p>You do not have access to this page.</p>
        </Col>
      </Row>
    </Container>
  </div>
);

export default PermissionDenied;
